import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextGroup, TextTypes, Badge, BadgeVariants } from '../../components/index';
import moment from 'moment';
import CardDesktop from '../../components/card-detail/card-desktop';
import { GiftCard, PaymentDetails } from '../../types/graphql-global-types';
import CardIcons from '../../components/card-icons';

interface OrderDesktopProps {
    order: any;
    setBalance: (card: GiftCard) => Promise<void>;
    updateCardSchedule: (
        clientcardsrno: string,
        carddetid: number,
        shipdate: number,
    ) => Promise<void>;
}

const OrderDesktop = ({ order, ...props }: OrderDesktopProps) => {
    return (
        <Col>
            {order.paymentdetails?.map((payment: PaymentDetails) => {
                const { ipddate, ipdcctype, ipdstatus } = payment;
                return (
                    <Row className="payment" key={ipddate}>
                        <TextGroup
                            label="Total Amount"
                            value={'$' + payment.ipdpcamt?.toFixed(2)}
                            valueType={TextTypes.H4}
                        />
                        <TextGroup label="Billed to" value={order.sendername} />
                        <TextGroup
                            label="Card Type"
                            value={
                                <span>
                                    {CardIcons[ipdcctype || ''] || ipdcctype}
                                    &nbsp;&nbsp; {payment.ipdpcnoquad?.slice(-4)}
                                </span>
                            }
                        />
                        <TextGroup
                            label="Date & Time"
                            value={
                                <span>
                                    {moment(moment.utc(ipddate)).local().format('MM/DD/YYYY')}
                                    &nbsp;&nbsp;&nbsp;
                                    {moment(moment.utc(ipddate)).local().format('h:mm A')}
                                </span>
                            }
                        />
                        <TextGroup
                            label="Status"
                            value={
                                <Badge
                                    text={!ipdstatus ? 'Accepted' : 'Declined'}
                                    variant={
                                        !ipdstatus ? BadgeVariants.GREEN : BadgeVariants.HIBISCUS
                                    }
                                />
                            }
                        />
                    </Row>
                );
            })}
            {order.lineitems?.map((card: GiftCard) => (
                <CardDesktop
                    key={card.lineitemid}
                    card={card}
                    lineitems={order.lineitems}
                    setBalance={props.setBalance}
                    updateCardSchedule={props.updateCardSchedule}
                />
            ))}
        </Col>
    );
};

export default OrderDesktop;
